export class LogBatch {
    public idLogBatch: number;
    public idLogBatchStatus: number;
    public nameProject: string;
    public message: string;
    public messageFinish: string;
    public datetimeInclusion: Date;
    public datetimeFinish: Date;
}